import { UITheme, UIThemes } from '@agilox/ui-common';
import { Component, effect, input, model, output, untracked } from '@angular/core';
import { FormCheckboxControl } from '@angular/forms/signals';

@Component({
	selector: 'ui-toggle',
	templateUrl: './toggle.component.html',
})
export class ToggleComponent implements FormCheckboxControl {
	isOn = input<boolean>();
	disabled = input<boolean>(false);
	invalid = input<boolean>(false);
	tabindex = input<number>(0);
	color = input<UITheme>('primary');

	checked = model<boolean>(false);

	touch = output<void>();
	valueChanged = output<boolean>();
	toggled = output<boolean>();

	constructor() {
		effect(() => {
			const isOn = this.isOn();
			if (typeof isOn === 'boolean') {
				untracked(() => this.checked.set(isOn));
			}
		});
	}

	toggle(event: Event) {
		event.preventDefault();
		event.stopImmediatePropagation();
		event.stopPropagation();
		if (this.disabled()) {
			return;
		}

		this.checked.set(!this.checked());
		this.valueChanged.emit(this.checked());
		this.toggled.emit(this.checked());
		this.touch.emit();
	}

	onKeyDown(event: KeyboardEvent): void {
		if (event.key === 'Enter' || event.key === ' ') {
			event.preventDefault();
			event.stopPropagation();
			this.toggle(event);
		}
	}

	readonly UIThemes = UIThemes;
}
